import React from 'react';
import {View, Text} from 'native-base';
import {useTheme} from 'styled-components/native';
import {formatNumber} from '@eCommerce/frontend-legacy-shared-library-native';

export interface CurrentTierCreditsProps {
  tierCredits: number;
  isInOlympusBand?: boolean;
}

const CurrentTierCredits: React.FC<CurrentTierCreditsProps> = ({
  tierCredits,
  isInOlympusBand = false,
}) => {
  const theme = useTheme();
  const {shuttleGray} = theme.colors;

  return (
    <View
      flexDirection={isInOlympusBand ? 'column' : 'row'}
      alignItems={isInOlympusBand ? 'flex-start' : 'center'}>
      <Text
        fontFamily={'body'}
        fontSize={'11px'}
        fontWeight="bold"
        color={shuttleGray}>
        {formatNumber(tierCredits)}
      </Text>
      <Text
        fontFamily="body"
        fontSize={'11px'}
        color={shuttleGray}
        marginLeft={isInOlympusBand ? undefined : '4px'}>
        Tier Credits
      </Text>
    </View>
  );
};

export default CurrentTierCredits;
